<template>
	<div class="lumi-container">
		<slot></slot>
	</div>
</template>

<style lang="less" scoped>
	.lumi-container {
		max-width: 768px;
		margin: 0 auto;
	}
</style>

<script>
	export default {};
</script>



// WEBPACK FOOTER //
// LumiContainer.vue?830bd1c0